import { render, staticRenderFns } from "./ScoreChart-mock.vue?vue&type=template&id=c87e93f2"
import script from "./ScoreChart-mock.vue?vue&type=script&lang=js"
export * from "./ScoreChart-mock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports